<template>
    <main class="auth__layout">
        <div
            v-if="displayIntro && hasIntro"
            class="auth__intro"
            :class="{
                'full_height': introPage == 1
            }">
            <div class="auth__top__links intro">
                <span class="selected">Accueil</span>
                <span class="auth__top__links__separator"></span>
                <a :href="ThemeStore.helpUrl">Aide ?</a>
            </div>
            <AuthIntro
                :intro="ThemeStore.intro"
                @next="handleIntroChange"
                @toggleIntro="toggleIntro"/>
        </div>
        <div
            v-else
            class="auth__container">
            <div class="auth__top__links">
                <span class="selected">Accueil</span>
                <span class="auth__top__links__separator"></span>
                <a :href="ThemeStore.helpUrl">Aide ?</a>
            </div>
            <div :style="{'background-color': ThemeStore.loginPage.backgroundColor}"
            class="relative">
                <AuthBackground />
                <div class="auth__container__main absolute__position">
                    <div class="auth__container__main__description"
                    v-if="!hasIntro">
                        <div class="auth__container__main__content">
<!--                            <img-->
<!--                                v-if="ThemeStore.loginPage.logo && ThemeStore.loginPage.logo.url"-->
<!--                                :src="ThemeStore.loginPage.logo.url"-->
<!--                                :alt="ThemeStore.loginPage.logo.name || 'Logo'"-->
<!--                                class="auth__logo"/>-->
                            <h2
                                v-if="ThemeStore.loginPage.text"
                                :style="leftTextColor"
                                v-html="ThemeStore.loginPage.text.replace(/\n/g, '<br />')"/>
                        </div>
                    </div>
                    <div
                        class="auth__container__main__form md:absolute md:right-0 md:top-0"
                        :class="{
                            'after__intro': hasIntro,
                        }"
                        :style="authLayoutFormBackground">
                        <AuthSigninForm @processed="submit" :signinError="signinError"/>
                    </div>
                </div>
            </div>
        </div>
        <Footer class="signin__footer" />
    </main>
</template>
<script>
import { useThemeStore } from "@/store/ThemeStore";
import Footer from '@/components/Partials/Footer.vue'
import AuthSigninForm from '@/components/Auth/Signin/FormContent.vue'
import AuthIntro from '@/components/Auth/Signin/IntroContent.vue'
import AuthBackground from '@/components/Auth/Signin/Background.vue'

export default {
    props: {
        signinError: Boolean,
        resetProcessed: Boolean,
        processing: Boolean
    },
    data() {
        const ThemeStore = useThemeStore();   
        // check if intro has already been displayed
        const introCookie = this.$cookies.get('intro')
        const displayIntro = introCookie ? false : true

        return {
            ThemeStore: ThemeStore,
            LoginTheme: ThemeStore.loginPage,
            displayIntro: displayIntro,
            introPage: 1,
        }
    },
    components: {
        Footer,
        AuthIntro,
        AuthBackground,
        AuthSigninForm
    },
    computed: {
        hasIntro () {
            return Object.keys(this.ThemeStore.intro).length > 0
        },
        leftTextColor () {
            return {'color': this.LoginTheme.leftTextColor}
        },
        authLayoutFormBackground() {
            const LoginTheme = this.LoginTheme
            
            return {
                'background-image': 'linear-gradient(to bottom, '
                + LoginTheme.loginColorTop + ', '
                + LoginTheme.loginColorBot + ')'
            }
        }
    },
    methods: {
        submit (res) {
            this.$emit('processed', {
                username: res.username,
                password: res.password,
                remember: res.remember
            })
        },
        togglePassword () {
            this.passwordType = this.passwordType == 'password' ? 'text' : 'password'
        },
        toggleIntro() {
            // save in cookie the intro state
            this.$cookies.set('intro', 'true', { expires: '1Y' })
            this.displayIntro = false
        },
        handleIntroChange() {
            this.introPage++
        }
    }
}
</script>
